export const ExecutionOptions = [
  { id: 0, label: 'bid', value: 'bid' },
  { id: 1, label: 'executing_agency', value: 'executing_agency' },
];
